const SmallSpin = () => {
    return (
        <div className="flex text-xl text-white ">
            <p>L</p>
            <div className="w-6 h-6 border-4 border-white border-dashed rounded-full animate-spin">
            </div>
            <p>AdiNg ..</p>
        </div >
    );
};

export default SmallSpin;